module.exports = __webpack_public_path__ + "assets/img/poster_01.cab0e5ea.jpg";